import React, { CSSProperties, PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'
import Spinner from './Spinner'
import { Link } from 'react-router-dom'

export const HoverText = styled.div<{ textColor?: string, hoverColor?: string }>`
  cursor: pointer;
  ${({ textColor }) => `color: ${textColor ?? RADOM_COLORS.BLACK};`}

  :hover {  
    ${({ hoverColor }) => `color: ${hoverColor ?? RADOM_COLORS.GRAY_DARKEST};`}
  }
`

const PrimaryButtonInner = styled.button`
  background-color: ${RADOM_COLORS.NEW_BLUE};
  // background: linear-gradient(to right, ${RADOM_COLORS.ORANGE}, ${RADOM_COLORS.PURPLE});
  border-radius: 25px;
  padding: 10px 30px;
  outline: 0;
  border: 0;
  color: #FFF;
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 16px;
  height: fit-content;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transform: scale(1);

  :hover {
    transform: scale(1.01);
    opacity: 0.75;
  }
  
  :active {
    transform: scale(0.99);
    opacity: 0.9;
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;

    :active {
      color: #FFF;
    }
  }

  &:focus {
    box-shadow: 0 0 5px 1px ${RADOM_COLORS.NEW_BLUE};
  }
`

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean
  style?: CSSProperties
}

export const PrimaryButton = ({ disabled, ...props }: PropsWithChildren<ButtonProps>): ReactElement =>
  <PrimaryButtonInner style={props.style} disabled={props.isLoading || disabled} {...props}>
    {props.isLoading ? <Spinner style={{ borderColor: 'white' }} /> : props.children}
  </PrimaryButtonInner>

export const SecondaryButtonInner = styled.button`
  border: 1px solid;
  border-color: ${RADOM_COLORS.NEW_BLUE};
  border-radius: 25px;
  padding: 10px 30px;
  outline: 0;
  background: none;
  color: ${RADOM_COLORS.NEW_BLUE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 14px;
  height: fit-content;
  user-select: none;
  
  :hover {
    opacity: 0.75;
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.75;
  }
  
  :active {
    opacity: 0.5;
  }
`

export const SecondaryButton = ({ disabled, ...props }: PropsWithChildren<ButtonProps>): ReactElement =>
  <SecondaryButtonInner style={props.style} disabled={props.isLoading ?? disabled} {...props}>
    {props.isLoading ? <Spinner style={{ borderColor: 'white' }} /> : props.children}
  </SecondaryButtonInner>

export const SecondaryLinkButton = styled(Link)`
  border: 1px solid;
  border-color: ${RADOM_COLORS.ORANGE};
  border-radius: 5px;
  padding: 5px 20px;
  outline: 0;
  background: none;
  color: ${RADOM_COLORS.ORANGE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 14px;
  height: fit-content;
  user-select: none;
  text-decoration: none;
  
  :hover {
    opacity: 0.75;
    text-decoration: underline;
  }
  
  :active {
    opacity: 0.5;
  }
`

export const PrimaryLinkButton = styled.a`
  background-color: ${RADOM_COLORS.NEW_BLUE};
  border-radius: 25px;
  padding: 10px 30px;
  outline: 0;
  border: 0;
  color: #FFF;
  cursor: pointer;
  transition: 0.2s ease all;
  text-decoration: none;
  font-size: 16px;
  height: fit-content;
  user-select: none;
  
  :hover {
    opacity: 0.75;
  }
  
  :active {
    opacity: 0.5;
  }
`

export const IconButton = styled.button`
  border: 0;
  border-radius: 5px;
  padding: 5px 20px;
  outline: 0;
  background: none;
  color: ${RADOM_COLORS.ORANGE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 12px;
  height: fit-content;
  user-select: none;
  display: flex;
  align-items: center;
  
  :hover {
    opacity: 0.75;
  }
  
  :active {
    opacity: 0.5;
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

export const IconLinkButton = styled(Link)`
  border: 0;
  border-radius: 5px;
  padding: 5px;
  outline: 0;
  background: none;
  color: ${RADOM_COLORS.ORANGE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 12px;
  height: fit-content;
  user-select: none;
  display: flex;
  align-items: center;
  
  :hover {
    opacity: 0.75;
  }
  
  :active {
    opacity: 0.5;
  }
`
